/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import config from "../../../config/config"
import { useSelector } from 'react-redux';
import { usePopupManager } from "../../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../../constants";
import axios from "axios";

import DashboardSection from '../../DashboardContainer/DashboardSection';
import QualityTileComp from "../../QualityComp/TileComponentQuality/QualityTileComp";
import TrademarkBarChart from '../../TrademarkBarChart/TrademarkBarChart';
import LegalPieChart from '../../LegalPieChart/LegalPieChart';
import ComplaintDisputeChart from '../../ComplaintDisputeChart/ComplaintDisputeChart';
import ComplaintDisputeBarChart from '../../ComplaintDisputeChart/ComplaintBarChart';
import DomainTile from '../../DomainTile/DomainTile';
import styles from './MainDashBoardAgratas.module.css';
import './MainDashBoardAgratas.css';
import RecordToReportPieChart from '../RecordToReportPieChart/RecordToReportPieChart';
import RecordToReportBarChart from '../RecordToReportBarChart/RecordToReportBarChart';
import RecordToReportSingleBar from '../RecordToReportSingleBar/RecordToReportSingleBar';
import ReportsStatusBarChart from '../ReportsStatusBarChart/ReportsStatusBarChart';
import DetailedDomainTile from '../../../atomicComponents/DetailedDomainTile/DetailedDomainTile';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import TrendIndicator from '../RecordToReportTrendIndicator/RecordToReportTrendIndicator';
import AgrTileComp from "./AgrTileComp";
import RecordBarChart from "../RecordToReportBarChart/RecordBarChart";

const WeekOptions = [
    { value: 'undefined', label: 'Select' },
    { value: 'All', label: '-All-' },
    ...Array.from({ length: 52 }, (_, i) => ({
        value: `W${i + 1}`,
        label: `Week ${i + 1}`
    }))
];

const { API_BASE_URL } = config;

const MainDashBoardAgratas = () => {

    const token = useSelector((state) => state.auth.djangoAccessToken);
    const roles = useSelector((state) => state.auth.djangoRoles);
    const userInfo = useSelector((state) => state.auth.djangoUserInfo);

    const location = useLocation();
    const { showPopup } = usePopupManager();

    const initialFilters = location.state || {
        regionData: [],
        yearData: [],
        monthData: [],
    };

    const [hasApplied, setHasApplied] = useState(false);

    const [filters, setFilters] = useState(initialFilters);

    const [showDashboard, setShowDashboard] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [regionOptions, setRegionOptions] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);

    const [region, setRegion] = useState([]);
    const [year, setYear] = useState([]);
    const [month, setMonth] = useState([]);

    const [week, setWeek] = useState(WeekOptions[0]);
    const [ValueOfAssetCapitalzation, setValueOfAssetCapitalzation] = useState([])
    const [assetLabel,setAssetLabel] = useState([])
    const [timeliness,setTimeliness]=useState([])
    const [VolumeOfJournalEntries,setVolumeOfJournalEntries]=useState([])
    const [volLabel,setVolLabel] = useState([])

    const history = useHistory()

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '20px',
            flexWrap: 'wrap',
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '50px',
            overflowY: 'auto',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            overflow: 'visible',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            overflowX: 'auto',
            whiteSpace: 'nowrap',
        }),
        option: (provided) => ({
            ...provided,
            padding: '8px 12px',
        }),
    };

    const handleRegionChange = (selected) => {
        const updatedRegions = selected || [];
        setRegion(updatedRegions);
        setFilters(prev => ({ ...prev, regionData: updatedRegions }));
    };

    const handleYearChange = (selected) => {
        const updatedYears = selected || [];
        setYear(updatedYears);
        setFilters(prev => ({ ...prev, yearData: updatedYears }));
    };

    const handleMonthChange = (selected) => {
        const updatedMonths = selected || [];
        setMonth(updatedMonths);
        setFilters(prev => ({ ...prev, monthData: updatedMonths }));
    };

    const handleWeekChange = (selected) => {
        setWeek(selected);
        setFilters(prev => ({ ...prev, weekData: selected }));
    };

    const handleApply = () => {
        const regionFilterData = region?.map(r => r?.value) || [];
        const yearFilterData = year?.map(y => y?.value) || [];
        const monthFilterData = month?.map(m => m?.value) || [];

        if (!yearFilterData || yearFilterData.length === 0) {
            showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Please select year.",
            });
            return;
        }
            
        setIsLoading(true);

        const fetchAgrTimlinessData = async () => {
            try {
                const response = await axios.post(`${API_BASE_URL}/api/Agratas-timeliness`,
                    {
                        selectedRegion: regionFilterData,
                        selectedYear: yearFilterData,
                        selectedMonth: monthFilterData,
                    },
                    {
                        headers: {
                            // Authorization: `Bearer ${token}`,
                            Authorization: 'Basic YWRtaW4xOjEyMw==',
                        }
                    },
                )
                    .then((response) => {
                        const result = response.data;
                        setTimeliness(result)
                    })
            } catch (error) {
                console.error('Error fetching Agratas Timeliness of Schedule Data options:', error);
            }
        };

        const fetchAgrVolumeData = async () => {
            try {
                const response = await axios.post(`${API_BASE_URL}/api/Agratas-volume`,
                    {
                        selectedRegion: regionFilterData,
                        selectedYear: yearFilterData,
                        selectedMonth: monthFilterData,
                    },
                    {
                        headers: {
                            // Authorization: `Bearer ${token}`,
                            Authorization: 'Basic YWRtaW4xOjEyMw==',
                        }
                    },
                )
                    .then((response) => {
                        const result = response.data;
                        setVolumeOfJournalEntries([result])
                        setVolLabel(result.label)
                    })
            } catch (error) {
                console.error('Error fetching Agratas Volume of Journal Data options:', error);
            }
        };

        const fetchAgrValueData = async () => {
            try {
                const response = await axios.post(`${API_BASE_URL}/api/Agratas-assetcap`,
                    {
                        selectedRegion: regionFilterData,
                        selectedYear: yearFilterData,
                        selectedMonth: monthFilterData,
                    },
                    {
                        headers: {
                            // Authorization: `Bearer ${token}`,
                            Authorization: 'Basic YWRtaW4xOjEyMw==',
                        }
                    },
                )
                    .then((response) => {
                        const result = response.data;
                        setValueOfAssetCapitalzation([result])
                        setAssetLabel(result.label)
                    })
            } catch (error) {
                console.error('Error fetching Agratas Value of Asset Capitalization Data options:', error);
            }
        };

        Promise.all([fetchAgrTimlinessData(), fetchAgrVolumeData(), fetchAgrValueData()]).then(() => {
            setShowDashboard(true);
            setIsLoading(false);
        });
    };

    const handleReset = () => {
        setRegion([]);
        setYear([]);
        setMonth([]);
        setWeek(WeekOptions[0]);
        setFilters({
            regionData: [],
            yearData: [],
            monthData: [],
            weekData: null,
        });
        setShowDashboard(false);
    };

    const fetchRegionOptions = async () => {
        try {
            const response = await axios
                .get(`${API_BASE_URL}/api/Agratas-region`, {
                    headers: {
                        // Authorization: `Bearer ${token}`,
                        Authorization: "Basic YWRtaW4xOjEyMw==",
                    },
                })
                .then((response) => {
                    setRegionOptions(response.data);
                });
        } catch (error) {
            console.error("Error fetching Agratas-region options:", error);
        }
    };

    const fetchYearOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/Agratas-year`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setYearOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching Agratas-year options:', error);
        }
    };

    const fetchMonthOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/Agratas-month`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setMonthOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching Agratas-month options:', error);
        }
    };

    useEffect(() => {
        fetchRegionOptions();
        fetchYearOptions();
        fetchMonthOptions();
    }, []);

    useEffect(() => {
        if (regionOptions.length && yearOptions.length && monthOptions.length) {

            if (filters.regionData && filters.regionData.length > 0) {
                const reg = regionOptions.filter(opt =>
                    filters.regionData.some(m => m.value === opt.value)
                );
                if (reg.length > 0) setRegion(reg);
            }

            if (filters.yearData && filters.yearData.length > 0) {
                const yr = yearOptions.filter(opt =>
                    filters.yearData.some(m => (m?.value ?? m) === opt.value)
                );
                if (yr.length > 0) setYear(yr);
            }

            if (filters.monthData && filters.monthData.length > 0) {
                const mon = monthOptions.filter(opt =>
                    filters.monthData.some(m => m.value === opt.value)
                );
                if (mon.length > 0) setMonth(mon);
            }

            if (filters.yearData && filters.yearData.length > 0) {
                setTimeout(() => {
                    setHasApplied(true);
                }, 1000);
            }
        }
    }, [regionOptions, yearOptions, monthOptions]);

    useEffect(() => {
        if (hasApplied === true) {
            handleApply();
            setHasApplied(false);
        }
    }, [hasApplied]);

    const amberGradient = 'linear-gradient(135deg, #FBBF24 0%, #F97316 100%)';
    const paidOnTimeGradient = 'linear-gradient(135deg, #F43F5E 0%, #DB2777 100%)';
    const blueGradient = 'linear-gradient(135deg, #3B82F6 0%, #4F46E5 100%)';
    const indigoGradient = 'linear-gradient(135deg, #6366F1 0%, #7C3AED 100%)';
    const purpleGradient = 'linear-gradient(135deg, #8B5CF6 0%, #C026D3 100%)';
    const emeraldGradient = 'linear-gradient(135deg, #10B981 0%, #0D9488 100%)';


    return (
        <>
        <div className="row" >
          <div className="col-md-12">
            <DomainTile title='Record-To-Report Agratas' showBackButton={true}
              mainPagePath = "/Record-To-Report"/>
          </div>
        </div>
 
            <div className={styles.filter_panel_container}>
                <div className={styles.filter_panel_row}>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Region</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={region}
                                onChange={handleRegionChange}
                                options={regionOptions}
                                isSearchable={true}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Year<span style={{ color: 'red' }}>*</span></label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={year}
                                onChange={handleYearChange}
                                options={yearOptions}
                                isSearchable={true}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Month</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={month}
                                onChange={handleMonthChange}
                                options={monthOptions}
                                isSearchable={true}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                    {/* <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Week</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={week}
                                onChange={setWeek}
                                options={WeekOptions}
                                isSearchable={true}
                            />
                        </div>
                    </div> */}
                    <div className="filter-panel-col action-buttons">
                        <button onClick={handleApply} className="btn apply-btn">
                            Apply
                        </button>
                        <button onClick={handleReset} className="btn reset-btn">
                            Reset
                        </button>
                    </div>
                </div>
            </div>

            {isLoading && (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    zIndex: 9999,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                >
                <div className="text-center">
                    <div className="spinner-border text-primary mb-3" role="status"></div>
                    <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
                </div>
            </div>
            )}

            {showDashboard && (
            <>
            {/* Second Row */}
            <div className='row'>
                <div className="col-md-12 col-lg-12 mb-2">
                    <DetailedDomainTile title='Period End Closing' showButton={true} path='/Record-To-Report/Agratas/TimeLiness' detailState={filters} />
                </div>
            </div>

            <div className='row'>
                <div className='col-4'>
                    <DashboardSection title="Timeliness of Schedules" showDetailView={false} infoIcondata={"Manual CSV DATA"}>
                        <div className='row' style={{display:"flex",justifyContent:"center"}}>
                            <div className='row mb-1'>
                                <RecordToReportPieChart filedBy={timeliness?.completed_on_time} filedAgainst={timeliness?.not_completed_on_time} Labels={['Completed In Time', 'Not Completed In Time']} />
                            </div>
                            <AgrTileComp
                                title="Total completion percentage"
                                number={timeliness?.completion_percentage??0}
                                gradient={emeraldGradient}
                            />
                        </div>
                    </DashboardSection>
                </div>
                <div className='col-4'>
                    <DashboardSection title="Completion of Journal Entries Requests" showDetailView={false} infoIcondata={"Manual CSV DATA"}>
                        <RecordBarChart labels={[volLabel]} datasets={VolumeOfJournalEntries} height={300} showLegend={false} hoverLabel={true}/>
                    </DashboardSection>
                </div>
                <div className='col-4'>
                    <DashboardSection title="Value of Asset Capitalization" showDetailView={false} infoIcondata={"Manual CSV DATA"}>
                        <RecordBarChart labels={[assetLabel]} datasets={ValueOfAssetCapitalzation} height={300} showLegend={false} hoverLabel={true}/>
                    </DashboardSection>
                </div>
            </div>
            </>
            )}
        </>
    );
};

export default MainDashBoardAgratas;